import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PartnerConsListComponent } from './take-action/partner-cons-list/partner-cons-list.component';
import { SecondaryNavbarComponent } from './secondary-navbar/secondary-navbar.component';
import { PartnerConsltantsDashboardComponent } from './partner-consltants-dashboard/partner-consltants-dashboard.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { WorkorderComponent } from './DynamicDocuments/workorder/workorder.component';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule,MatTableDataSource} from '@angular/material/table';
import { NgxSpinnerModule } from "ngx-spinner";
import { environment } from 'src/environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import {BsDatepickerModule,BsDatepickerConfig} from 'ngx-bootstrap/datepicker'
import { DatePipe } from '@angular/common';
import { debounceTime, map } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { PartnerConsCompleteddocsComponent } from './partner-cons-completeddocs/partner-cons-completeddocs.component';
import { PartnerChildConsCompleteddocsComponent } from './partner-child-cons-completeddocs/partner-child-cons-completeddocs.component';
import { ViewVendorConInformationDocsComponent } from './view-vendor-con-information-docs/view-vendor-con-information-docs.component';
import { ViewVendorChildConsInformationDocsComponent } from './view-vendor-child-cons-information-docs/view-vendor-child-cons-information-docs.component';
import { WorkorderSpecialComponent } from './DynamicDocuments/workorder-special/workorder-special.component';
import { WorkorderCanadaComponent } from './DynamicDocuments/workorder-canada/workorder-canada.component';
import { TwoDigitDecimaNumberDirective } from './DynamicDocuments/two-digit-decima-number.directive'
import { AuthInterceport } from './service/auth-interceptor';
export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    dateInputFormat: 'MM/DD/YYYY',
    containerClass: 'theme-blue'
  });
}
@NgModule({
  declarations: [
    AppComponent,
    PartnerConsListComponent,
    SecondaryNavbarComponent,
    PartnerConsltantsDashboardComponent,
    PartnerConsCompleteddocsComponent,
    WorkorderComponent,
    PartnerChildConsCompleteddocsComponent,
    ViewVendorConInformationDocsComponent,
    ViewVendorChildConsInformationDocsComponent,
    WorkorderSpecialComponent,
    WorkorderCanadaComponent,
    TwoDigitDecimaNumberDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    ToastrModule.forRoot({
      positionClass :'toast-top-right'
    }),
    NgxSpinnerModule,
    BrowserAnimationsModule,
    NgSelectModule,
    MatSortModule,
    MatTableModule,
    HttpClientModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    BsDatepickerConfig,
    DatePipe,
    { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceport,
      multi: true
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
